<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thông tin cấu hình hiển thị</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên:"
                  label-for="title"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    class="col-10"
                    v-if="editing"
                    v-model="$v.configDisplay.name.$model"
                    :state="
                      $v.configDisplay.name.$dirty
                        ? !$v.configDisplay.name.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    configDisplay.name
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Các danh mục hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <treeselect
                    class="col-10 no-padding"
                    id="categoryId"
                    :multiple="true"
                    v-if="editing && categories.length > 0"
                    v-model="configDisplay.categoryIds"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                  <label class="col-form-label col-10" v-if="!editing">{{
                    configDisplay.categoryName
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Số phần tử hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-if="editing"
                    v-model="configDisplay.numberShow"
                  >
                  </b-form-input>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    configDisplay.numberShow
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Số thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-if="editing"
                    v-model="configDisplay.orderDisplay"
                  >
                  </b-form-input>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    configDisplay.orderDisplay
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="2">
                  <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="back"
                    v-if="!editing"
                    >Quay lại</b-button
                  >
                  <b-button
                    type="submit"
                    variant="primary"
                    v-if="editing && authorize(['ManageConfigDisplay'])"
                    >Ghi lại</b-button
                  >
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="cancel"
                    v-if="editing"
                    >Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { authorizationMixin } from "@/shared/mixins";
import { mapState } from "vuex";

export default {
  name: "ConfigDisplayDetail",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      configDisplay: {
        file: null,
        categoryIds: [],
      },
      editing: this.$route.meta.editing,
    };
  },
  computed: {
    sliderId() {
      return this.$route.params.sliderId;
    },
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
  },
  validations: {
    configDisplay: {
      name: { required },
    },
  },
  watch: {},
  created() {
    this.loadConfigDisplayDetail();
  },
  methods: {
    loadConfigDisplayDetail() {
      var vm = this;
      return this.$services
        .get(`system/config-display/${this.sliderId}`)
        .done((configDisplay) => {
          vm.configDisplay = configDisplay;
        });
    },
    edit() {
      this.editing = true;
    },
    back() {
      this.$router.push({ path: "/system/config-display" });
    },
    cancel() {
      var vm = this;
      this.loadConfigDisplayDetail().done(() => (vm.editing = false));
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services
          .put(`system/config-display/${this.sliderId}`, this.configDisplay)
          .done(() => {
            vm.$toastr.s("Cập nhật thành công");
            vm.cancel();
          });
      }
    },
    getUrlImage(path) {
      return this.$services.getResourceUrl() + path;
    },
  },
};
</script>
<style>
/*  .ck-editor__editable {
        min-height: 500px;
    }*/
.ck-editor .ck-editor__main .ck-content {
  min-height: 200px;
}

.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
<style scoped>
.wh200 {
  width: 200px;
}
.w300 {
  width: 300px;
}
</style>